import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {FullChild} from "../../../../../interfaces/FullChild";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../../interfaces/Centres";
import {CentreService} from "../../../../../services/centre.service";
import {ChildService} from "../../../../../components/child/child.service";
import {NgxPrintService} from "ngx-print";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSelectChange} from "@angular/material/select";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {MatTableDataSource} from "@angular/material/table";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-child-case-study-view',
  templateUrl: './child-case-study-view.component.html',
  styleUrls: ['./child-case-study-view.component.scss']
})
export class ChildCaseStudyViewComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private readonly _destroyed$ = new Subject<void>();
  mSelectedCentre: any;
  selectedChildId: any;
  mChildren!: FullChild[];
  centres$!: Observable<Centre[]>;
  mChildData: any;
  @ViewChild('content') content!: ElementRef;
  photoUrl: string | undefined;
  narrative: string='';
  mId:any
  editMode=false
  constructor(
    private readonly mCentreService: CentreService,
    private readonly mSnackBar: MatSnackBar,
    private readonly mChildService: ChildService,
    private readonly mFirestore: AngularFirestore,
    private route: ActivatedRoute
  ) {
    this.centres$ = this.mCentreService.getAllCentres();

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mId = res['id']
      console.log("mid", this.mId)
      if (this.mId) this.mFirestore.collection(this.env.childCaseStudy).doc(this.mId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
        if (this.mId != undefined) {
          const childData = res;
          this.mChildData = {
            narrative: childData.narrative,
            age: childData.age,
            city: childData.city,
            gender: childData.gender,
            firstName: childData.firstName,
            lastName: childData.lastName,
            diagnosis: childData.diagnosis,
            state: childData.state,
            hospital: childData.hospital,
            admissionDocuments: childData.admissionDocuments, // Process the URL as needed
          }
        }
      })
    })

  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      const childId = params.get('id');
      console.log('childId',childId)
      if (childId) {
        // Editing mode
        this.selectedChildId = childId;
        this.editMode = true;
        console.log('into if childId')
        this.fetchChildData(childId);  // Fetch data to populate form for editing
      } else {
        // Adding new case study
        this.editMode = false;// Ensure form is reset for new data entry
      }
    });
  }


  fetchChildData(childId: string): void {
    console.log('int fecth CHildData')
    this.mFirestore.collection(this.env.childCaseStudy).doc(childId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
      console.log('childdata res',res)
      if (res) {
        this.mChildData = []
        console.log(res)
        const data = {
          narrative: res.narrative,
          age: res.age,
          city: res.city,
          gender: res.gender,
          firstName: res.firstName,
          lastName: res.lastName,
          diagnosis: res.diagnosis,
          state: res.state,
          hospital: res.hospital,
          admissionDocuments: res.admissionDocuments, // Process the URL as needed
        }
        this.mChildData.push(data)
        console.log(this.mChildData)
        this.narrative = res.narrative
      }

    });
  }






  printDoc(): void {
    const content = this.content.nativeElement;
    setTimeout(() => {
      html2canvas(content).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF();
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        doc.addImage(imgData, 'PNG', 15, 15, pdfWidth - 30, pdfHeight - 30);
        doc.save('document.pdf');
      }).catch(err => {
        console.error('html2canvas Error:', err);
      });
    }, 1000);
  }

  printDoc2(): void {
    const previewElement = document.getElementById('previewChildCaseStudyReports');
    if (!previewElement) {
      console.error('Element with ID "preview" not found.');
      return;
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Child Case Study</title>
            <style>
              @media print {
                body { margin: 0; padding: 0; }
                .page { padding: 10px; margin: 10px; page-break-after: always; }
                .page:before {
                  content: '';
                  position: fixed;
                  top: 0; left: 0; right: 0; bottom: 0;
                  border: 1px solid #000;
                  pointer-events: none;
                  z-index: -1;
                }
              }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            <div class="page">${previewElement.innerHTML}</div>
          </body>
        </html>
      `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}


